document.documentElement.classList.remove('no-js');

const body = document.body;
const moneyFormat = window.Shopify?.currency?.active || 'MYR';

function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en-MY', {
    style: 'currency',
    currency: moneyFormat,
  }).format(Number(cents || 0) / 100);
}

function openPanel(id) {
  const panel = document.getElementById(id);
  if (!panel) return;
  document.querySelectorAll('.drawer.is-open').forEach((item) => item.classList.remove('is-open'));
  panel.classList.add('is-open');
  panel.setAttribute('aria-hidden', 'false');
  body.classList.add('drawer-open');
  const focusTarget = panel.querySelector('input, button, a');
  window.setTimeout(() => focusTarget?.focus(), 180);
}

function closePanels() {
  document.querySelectorAll('.drawer.is-open').forEach((panel) => {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
  });
  body.classList.remove('drawer-open');
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-drawer-open]');
  if (trigger) {
    event.preventDefault();
    openPanel(trigger.dataset.drawerOpen);
    return;
  }
  if (event.target.closest('[data-drawer-close]')) closePanels();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    closePanels();
    document.querySelectorAll('.discount-modal.is-open').forEach((modal) => modal.classList.remove('is-open'));
    body.classList.remove('modal-open');
  }
});

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, {threshold: 0.08});
document.querySelectorAll('[data-reveal]').forEach((item) => revealObserver.observe(item));

async function getCart() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`, {headers: {'Accept': 'application/json'}});
  return response.json();
}

function cartLineMarkup(item) {
  const image = item.image ? `<img class="cart-line__image" src="${item.image}" alt="">` : '';
  const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${item.variant_title}</p>` : '';
  return `<li class="cart-line">${image}<div><a class="cart-line__title" href="${item.url}">${item.product_title}</a>${variant}<p class="cart-line__price">${formatMoney(item.final_line_price)} · Qty ${item.quantity}</p></div><button class="cart-line__remove" type="button" data-cart-remove="${item.key}" aria-label="Remove item"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14"/></svg></button></li>`;
}

async function renderCart(openAfter = false) {
  const cart = await getCart();
  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    count.textContent = cart.item_count;
    count.hidden = cart.item_count === 0;
    count.classList.add('is-bumped');
    window.setTimeout(() => count.classList.remove('is-bumped'), 400);
  });
  const bodyTarget = document.querySelector('[data-cart-drawer-body]');
  const footer = document.querySelector('[data-cart-drawer-footer]');
  if (bodyTarget) {
    bodyTarget.innerHTML = cart.item_count
      ? `<ul class="cart-lines">${cart.items.map(cartLineMarkup).join('')}</ul>`
      : '<div class="drawer-empty"><svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/></svg><h3>Your cart is empty</h3><p>Looks like you haven\'t added anything yet.</p></div>';
  }
  if (footer) {
    footer.hidden = cart.item_count === 0;
    const subtotal = footer.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }
  if (openAfter) openPanel('CartDrawer');
}

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const originalText = button?.textContent;
  if (button) {
    button.disabled = true;
    button.textContent = 'Adding…';
  }
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {'Accept': 'application/json'},
      body: new FormData(form),
    });
    if (!response.ok) throw new Error('Unable to add this item');
    const item = await response.json();
    document.dispatchEvent(new CustomEvent('br:add-to-cart', {detail: item}));
    await renderCart(true);
  } catch (error) {
    window.alert(error.message);
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }
});

document.addEventListener('click', async (event) => {
  const remove = event.target.closest('[data-cart-remove]');
  if (!remove) return;
  remove.disabled = true;
  await fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify({id: remove.dataset.cartRemove, quantity: 0}),
  });
  await renderCart();
});

document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
  const input = wrapper.querySelector('input');
  wrapper.addEventListener('click', (event) => {
    const control = event.target.closest('[data-quantity-change]');
    if (!control || !input) return;
    const value = Math.max(1, Number(input.value || 1) + Number(control.dataset.quantityChange));
    input.value = value;
  });
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const variants = JSON.parse(root.querySelector('[data-variants-json]')?.textContent || '[]');
  const idInput = root.querySelector('[name="id"]');
  const price = root.querySelector('[data-product-price]');
  const compare = root.querySelector('[data-product-compare]');
  const addButton = root.querySelector('[data-add-button]');
  const mainImage = root.querySelector('[data-gallery-main]');

  function updateVariant() {
    const values = [...root.querySelectorAll('[data-option-group]')].map((group) => group.querySelector('.is-selected')?.dataset.optionValue);
    const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
    if (!variant) {
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    price.textContent = formatMoney(variant.price);
    if (compare) {
      const onSale = Number(variant.compare_at_price || 0) > Number(variant.price);
      compare.hidden = !onSale;
      compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
    }
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (variant.featured_image?.src && mainImage) {
      mainImage.src = variant.featured_image.src;
      const matchingThumb = root.querySelector(`[data-image-src="${CSS.escape(variant.featured_image.src)}"]`);
      root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === matchingThumb));
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('[data-option-button]').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('[data-option-group]').querySelectorAll('[data-option-button]').forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
      updateVariant();
    });
  });

  root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      mainImage.src = thumb.dataset.imageSrc;
      root.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.toggle('is-active', item === thumb));
    });
  });
});

const searchInput = document.querySelector('[data-predictive-search-input]');
const searchResults = document.querySelector('[data-predictive-search-results]');
let searchTimer;
searchInput?.addEventListener('input', () => {
  window.clearTimeout(searchTimer);
  const query = searchInput.value.trim();
  if (query.length < 2) {
    searchResults.innerHTML = '';
    return;
  }
  searchTimer = window.setTimeout(async () => {
    const response = await fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
    const data = await response.json();
    const products = data.resources?.results?.products || [];
    searchResults.innerHTML = products.length
      ? products.map((product) => `<a class="predictive-item" href="${product.url}">${product.image ? `<img src="${product.image}" alt="">` : ''}<span><span class="predictive-item__title">${product.title}</span><span class="predictive-item__price">${product.price}</span></span></a>`).join('')
      : '<p>No results found</p>';
  }, 180);
});

document.querySelectorAll('[data-sort-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url);
  });
});

document.querySelectorAll('[data-discount-popup]').forEach((modal) => {
  const key = `br-popup-${modal.dataset.discountPopup}`;
  const delay = Number(modal.dataset.delay || 6) * 1000;
  if (!window.sessionStorage.getItem(key)) {
    window.setTimeout(() => {
      modal.classList.add('is-open');
      body.classList.add('modal-open');
      window.sessionStorage.setItem(key, 'shown');
    }, delay);
  }
  modal.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', () => {
    modal.classList.remove('is-open');
    body.classList.remove('modal-open');
  }));
  modal.querySelector('[data-discount-code]')?.addEventListener('click', async (event) => {
    await navigator.clipboard?.writeText(event.currentTarget.dataset.discountCode);
    event.currentTarget.querySelector('small').textContent = 'Copied';
  });
});
